import React from "react";
import ChariotConnect from "react-chariot-connect";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { unwrapResult } from "@reduxjs/toolkit";

import {
  setCampaignThankOpen,
  setCommunityThankOpen,
  setDonationFormOpen,
  setStripeOpen,
} from "../../redux/state/donationSlice";
import {
  donateCampaignChariotRequest,
  getCommunityDonations,
  grandDonation,
} from "../../redux/state/paymentSlice";
import { getCommunity } from "../../redux/state/communitySlice";

const ID = process.env.REACT_APP_CHARIOT_KEY;

const Chariot = () => {
  const dispatch = useDispatch();
  const { communityId } = useParams();

  const isAdmin = useSelector((state) => state.community.community.role, shallowEqual);
  const body = useSelector((state) => state.donation.body, shallowEqual);

  const onChariotSuccess = (e) => {
    if (e.type !== "CHARIOT_SUCCESS" || !e.detail) {
      toast.info("Something went wrong");
      return;
    }
    const chariotWorkflowSessionId = e.detail.workflowSessionId;
    const amount = !!e.detail.grantIntent?.amount ? e.detail.grantIntent.amount / 100 : 0;
    const paymentId = e.detail.grantIntent?.metadata?.paymentId;
    dispatch(
      grandDonation({
        paymentId,
        chariotWorkflowSessionId,
        amount,
      })
    )
      .then(unwrapResult)
      .then(() => {
        toast.info("Success");
        chariotPaymentSuccessHandler();
      })
      .catch(({ title }) => toast.info(title));
  };

  const chariotPaymentSuccessHandler = () => {
    dispatch(setStripeOpen(false));
    if (!communityId) return;
    const campaignId = body.campaignId;
    if (!campaignId) {
      dispatch(getCommunity(communityId));
      dispatch(
        getCommunityDonations({
          isAdmin,
          communityId,
          page: 1,
          pageSize: 8,
        })
      );
      dispatch(setCommunityThankOpen(true));
      return;
    }
    dispatch(setCampaignThankOpen(true));
  };

  const onDonationRequest = () => {
    const campaignId = body.incomingBalanceId;
    if (!campaignId || !communityId) return;

    dispatch(setDonationFormOpen(false));
    return dispatch(
      donateCampaignChariotRequest({
        campaignId,
        communityId,
        body,
      })
    )
      .then(unwrapResult)
      .then((response) => {
        return response;
      })
      .catch(({ title }) => toast.info(title));
  };

  return (
    <div style={{ marginBottom: "16px", borderRadius: "10px", overflow: "hidden" }}>
      <ChariotConnect
        cid={ID}
        onDonationRequest={onDonationRequest}
        onSuccess={onChariotSuccess}
        theme={{
          height: "h-10",
        }}
        disabled={!body.amount}
      />
    </div>
  );
};

export default Chariot;
